import { render, staticRenderFns } from "./DeviceInfo.vue?vue&type=template&id=f0ab4fe0&scoped=true"
import script from "./DeviceInfo.vue?vue&type=script&lang=js"
export * from "./DeviceInfo.vue?vue&type=script&lang=js"
import style0 from "./DeviceInfo.vue?vue&type=style&index=0&id=f0ab4fe0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0ab4fe0",
  null
  
)

export default component.exports